import { inject, Injectable } from '@angular/core';

import { catchError, filter, from, map, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '@ngrx/store';
import { BaseEffects } from '@store/base.effects';
import { createEffect, ofType } from '@ngrx/effects';

import { PageMetasActions } from './page-metas.actions';

import { MenusResolver } from '@services/resolvers/menus/menus-resolver';

@Injectable({ providedIn: 'root' })
export class PageMetasEffects extends BaseEffects {
  private menusResolver = inject(MenusResolver);

  onLanguageChange$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(PageMetasActions.setLanguage),
      filter(action => action.fetchNav !== false),
      mergeMap(() => {
        return [PageMetasActions.fetchMainNavItems(), PageMetasActions.fetchFooterNavItems()];
      })
    )
  );

  fetchMainNavItems$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(PageMetasActions.fetchMainNavItems),
      mergeMap(() =>
        from(this.menusResolver.resolveMainMenu()).pipe(
          map(languageConfigs => PageMetasActions.fetchMainNavItemsSuccess({ payload: languageConfigs })),
          catchError(error => of(PageMetasActions.fetchMainNavItemsError({ error })))
        )
      )
    )
  );

  fetchFooterNavItems$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(PageMetasActions.fetchFooterNavItems),
      mergeMap(() =>
        from(this.menusResolver.resolveFooterMenu()).pipe(
          map(languageConfigs => PageMetasActions.fetchFooterNavItemsSuccess({ payload: languageConfigs })),
          catchError(error => of(PageMetasActions.fetchFooterNavItemsError({ error })))
        )
      )
    )
  );
}
